import { BadgePercent, MapPin, MessageCircle, Sparkles } from "lucide-react";

const ITEMS = [
  { icon: MapPin, title: "Singasandra, Bengaluru", testId: "trust-item-location" },
  { icon: Sparkles, title: "Multiple Massage Experiences", testId: "trust-item-services" },
  { icon: BadgePercent, title: "New Spa Opening — 20% OFF", testId: "trust-item-offer" },
  { icon: MessageCircle, title: "Easy WhatsApp Booking", testId: "trust-item-whatsapp" },
];

const TrustBar = () => (
  <section
    data-testid="trust-strip-container"
    aria-label="Quick information"
    className="border-b border-[#E7E2DA] bg-white"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-4 gap-y-5 px-4 py-6 sm:px-8 lg:grid-cols-4">
      {ITEMS.map(({ icon: Icon, title, testId }) => (
        <div key={testId} data-testid={testId} className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#FDF9F0] ring-1 ring-[#C5A059]/30">
            <Icon className="h-5 w-5 text-[#9E7B36]" aria-hidden="true" />
          </span>
          <p className="text-xs font-semibold leading-snug text-[#1C1917] sm:text-sm">{title}</p>
        </div>
      ))}
    </div>
  </section>
);

export default TrustBar;
